<template>
    <div
        class="w-100 cursor-pointer transition-all px-1 py-3 selector border-radius-1 d-flex flex-row justify-space-between align-center primary--text position-relative"
    >
        <v-icon :disabled="disabled" class="icon--disabled primary--text mx-3 icon-medium">{{ 'mdi-volume-off' }}</v-icon>
        <div class="d-flex w-100 align-center">
            <v-slider
                min="0"
                max="100"
                color="primary"
                height="15"
                hide-details
                v-model="soundVolume"
                @change="updateConfig"
                :disabled="disabled"
            />
        </div>
        <v-icon :disabled="disabled" class="icon--disabled primary--text mx-3 icon-medium">{{ 'mdi-volume-high' }}</v-icon>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    data() {
        return {
            soundVolume: 0,
        }
    },
    mounted() {
        this.soundVolume = this.soundVolumeValue
    },
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            challengeConf: (state) => state.challenge.config,
        }),
        soundVolumeValue() {
            let result = this.bookReadConf && this.bookReadConf.sound
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConf && this.challengeConf.soundVol
            }
            return result
        }
    },
    methods: {
        ...mapActions('bookReading', ['setBookReadSound']),
        ...mapActions('challenge', ['setChallengeSound']),
        updateConfig() {
            if (this.isBookFunctionality) {
                this.setBookReadSound(this.soundVolume)
            }
            if (this.isChallengeFunctionality) {
                this.setChallengeSound(this.soundVolume)
            }
        }
    }
}
</script>

<style>
.primary--border {
    border: 1.5px solid #514773 !important;
}
.selector {
    background: white !important;
}
</style>
